<template>
  <div>
    <el-card style="width: 40%;margin-bottom: 25px;border: none;margin-left:10px;box-shadow: none" class="box-card">
      <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer;"
        @click="isShow = !isShow">
        <span style="font-weight: bold;font-size: 14px;color: #636569">创建客户单位规则</span>
        <i class="el-icon-arrow-up" v-show="isShow"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="展开执行流程介绍">折叠</i>
        <i class="el-icon-arrow-down" v-show="!isShow"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="折叠执行流程介绍">展开</i>
      </div>
      <div v-if="isShow" style="margin-bottom: 10px;font-weight: bold;font-size: 14px;" class="text item">
        <div style="font-weight: bold;font-size: 14px;margin-left: 20px">1. 务必用正确单位，别额外加上（院/系等）：</div>
        <div style="font-weight: bold;font-size: 14px;margin-left: 20px">2. 单位名称请保持正确，别一会 xx院/ 一会xx所：</div>
        <div style="font-weight: bold;font-size: 14px;margin-left: 20px">3. 单位后面不要随意添加括号，空格，输入法一会中文，一会英文：</div>
        <div style="font-weight: bold;font-size: 14px;margin-left: 20px">4. 单位税号之间不要空格，创建单位的时候会做税号的唯一性检查：</div>
      </div>
    </el-card>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;">
        <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        <el-button size="small" type="danger" icon="el-icon-delete"
          v-if="['ADMIN','MANAGER','SALES_ASSI_MANAGER'].includes(role)" @click="handleDelete()">批量删除</el-button>
      </div>
      <export-components v-if="['ADMIN','MANAGER'].includes(role)" :apiFunction="exportCompany" :requestData="getSearch({})"
        :option="option" @sendData=getSearchData></export-components>
    </div>
    <div style="width:100%;">
      <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection"
        @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
        :table-col-check="{isShow:true,name:'CustomerCompany3'}" ref="wMyTable" :page="page"
        @pageChange="handlePagePagination" :isShowRowSelection="true">
        <div slot="operation" slot-scope="{text,record}">
          <el-button size="mini" type="primary" v-if="['ADMIN','MANAGER','SALES_ASSI_MANAGER'].includes(role)"
            @click="handleEdit(record)">编辑</el-button>
            <el-button size="mini" type="success" plain v-if="['ADMIN', 'MANAGER'].includes(role) && !record.enabled"
            @click="handleEnabled(record,true)">启用</el-button>
            <el-button size="mini" type="danger" plain v-if="['ADMIN', 'MANAGER'].includes(role) && record.enabled"
            @click="handleEnabled(record,false)">弃用</el-button>
          <el-button size="mini" type="danger"
            v-if="['ADMIN','MANAGER','SALES_ASSI_MANAGER'].includes(getDataInLocalStorage('role'))"
            @click="handleDelete(record)">删除</el-button>
        </div>
        <template slot="copyInfoData" slot-scope="{text, record,index}">
         <div v-if="text">
            <span>{{ text }}</span>
            <el-tooltip content="复制">
              <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
            </el-tooltip>
          </div>
        </template>
        <template slot="companyAddress" slot-scope="{text,record,index,column}">
          <div style="display: flex;align-items: center">
            <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
            <el-tooltip content="复制">
              <a-icon v-if="text" type="copy" style="color: #3f9dfe" @click="copyData(text)" />
            </el-tooltip>
          </div>
        </template>
        <template slot="enabled" slot-scope="{text,record,index,column}">
          <el-tag type="success" v-if="text">已启用</el-tag>
          <el-tag type="danger" v-else>已弃用</el-tag>
        </template>
        <template slot="bankAccountNumber" slot-scope="{text,record,index,column}">
          <div style="display: flex;align-items: center">
            <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
            <el-tooltip content="复制">
              <a-icon v-if="text" type="copy" style="color: #3f9dfe" @click="copyData(text)" />
            </el-tooltip>
          </div>
        </template>
      </w-table>
      <add-customer-dialog v-if="showAddEditCusDialog" :show-dialog="showAddEditCusDialog" :selectType="selectType"
        :select-detail="selectDetail" @submit="closeAddEditCusDialog">
      </add-customer-dialog>
      <picture-loading v-if="loading"></picture-loading>
    </div>
  </div>
</template>

<script>
import { deleteCompany, getCustomerCompanyPage, enabledCompany} from "@/api/dilivery/customer/company";
import {customerCompany} from "@/utils/data/tableCol/customer/customerCompany";
import AddCustomerDialog from "@/components/customer/AddCustomerDialog.vue";
import ReplaceByDelete from "@/components/ReplaceByDelete.vue";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {getDataInLocalStorage} from "@/utils/localStorage";
import {exportCompany} from "@/api/dilivery/export";
import {copyText} from "@/utils/windowsUtils";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import ExportComponents from "@/components/ExportComponents.vue";


export default {
  name: "CustomerCompany",
  components: { ExportComponents, PictureLoading, TableHeadNote, ReplaceByDelete, AddCustomerDialog},
  data() {
    return {
      ids: [],
      table: [],
      role:'',
      isShow:true,
      searchConditionTag: [],//搜索tag
      sortConditionTag: [],
      tableData: [],
      showAddEditCusDialog: false, //控制编辑页面显示与隐藏
      selectDetail: '',
      selectType: {},
      selectable: [],
      option: [
        {label: '创建时间', value: 'createTime'},
      ],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      deleterInfo: {},
      showDeleteDialog: false,
      loading :true,
    }
  },
  created() {
    this.role = getDataInLocalStorage('role')
  },
  computed: {
    columns() {
      return JSON.parse(JSON.stringify(customerCompany(this.searchConditionTag || {})))
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handleEnabled(record, enabled) {
      let params = {
        id: record.id,
        enabled: enabled
      }
      enabledCompany(params).then(res => {
        if (res.code === 200) {
          this.$messageUi({
            type: 'success',
            message: enabled ? '启用成功!' : '弃用成功!'
          })
          this.getData()
        }
      }).catch(err => {
      })
    },
    exportCompany,
    getDataInLocalStorage,
    //表格的选择框
    rowSelection(selectedRows) {
      this.ids = selectedRows.map(item => item.id)
      this.selectable = selectedRows
    },
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    // 获取数据
    getData(type) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      this.sortConditionTag.forEach(item => {
        params["order"] = item.colName + "." + item.order
      })
      if (type) {
        params['page.current'] = 1
        params['page.size'] = 10
      }
      let sendData = {}
      sendData = this.getSearch(sendData)
      getCustomerCompanyPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        if (this.option.map(it => it.value).includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = item.value
        } else {
          sendData["query#" + item.key + ".LIKE"] = item.value
        }
      })
      return sendData
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    //编辑
    handleEdit(row) {
      if (row !== undefined && row !== 'undefined') {
        this.selectDetail = row
        this.selectType = {
          type: 'edit'
        }
      } else {
        this.selectType = {
          type: 'add'
        }
        this.selectDetail = ''
      }
      this.showAddEditCusDialog = true
    },
    //删除
    handleDelete(row) {
      let ids = []
      if (row && row.id) {
        ids.push(row.id)
      } else {
        if (this.ids.length > 0) {
          ids = this.ids
        } else {
          this.$messageUi.error('请勾选要批量删除的数据')
          return
        }
      }
      this.$confirmUi('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        let param = {
          "ids" : ids.join(',')
        }
        deleteCompany(param).then(res => {
          if (res.code === 200) {
            this.$messageUi({
              type: 'success',
              message: '删除成功!'
            })
            this.ids = []
            const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize)
            this.page.currentNum = this.page.currentNum > totalPage ? totalPage : this.page.currentNum
            this.page.currentNum = this.page.currentNum < 1 ? 1 : this.page.currentNum
            this.getData()
          }
        }).catch(err => {
        })
      }).catch(() => {

      })
    },
    // 关闭编辑、增加、批量添加弹出框
    closeAddEditCusDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() =>{
        this.showAddEditCusDialog = false
      })
    },
    //根据文本长度调整展示的内容
    computerNote(text) {
      if (text) {
        if (text.length <= 4) {
          return text
        } else {
          return text.substring(0, 4)
        }
      } else {
        return ''
      }
    },
    // 复制
    copyData(text){
      copyText(text)
      this.$messageUi.success('复制成功')
    }
  }
}
</script>

<style scoped>

</style>
